<template>
    <section>
        <div class="bg-white shadow-md rounded-lg p-4 my-3 mx-6 mb-80 h-full">
            <h1 class="font-semibold mb-2">{{ titulo }}</h1>

            <slot></slot>

            <div v-if="labelIndicacao != ''" class="flex items-center text-azul-info justify-center mt-2">
                <Icone :nome="'touch_app'" /> <span>{{ labelIndicacao }}</span>
            </div>

            <div v-if="!exibirLoader">
                <div
                    class="flex items-center justify-between fixed bottom-0 w-full bg-white px-4 pt-5 pb-10 left-1/2 -translate-x-1/2">
                    <button class="font-semibold" @click="voltar()">
                        Voltar
                    </button>
                    <button class="botao-salvar" @click="salvar()">
                        <Icone :nome="'check_circle'" /> {{ labelBotaoSalvar }}
                    </button>
                </div>
            </div>
            <div v-else class="flex flex-col justify-center items-center gap-1 p-4">
                <Loader></Loader> <span class="text-sm">Salvando imagem e coordenadas</span>
            </div>
        </div>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import Loader from '@/components/Loader.vue';
import Icone from './Icone.vue';

export default defineComponent({
    name: 'Detalhes',
    components: {
        Loader,
        Icone
    },
    props: {
        titulo: {
            type: String,
            required: true
        },
        labelBotaoSalvar: {
            type: String,
            default: 'Salvar'
        },
        exibirLoader: {
            type: Boolean,
            default: false
        },
        labelIndicacao: {
            type: String,
            default: ''
        }
    },
    emits: ['aoSair', 'aoSalvar'],
    methods: {
        salvar() {
            this.$emit('aoSalvar')
        },
        voltar() {
            this.$emit('aoSair')
        }
    }
});
</script>